import * as React from "react";
import type { SVGProps } from "react";
const SvgShip = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="#352F28"
      fillRule="evenodd"
      d="M5 4a1 1 0 0 0-1 1v5H3a1 1 0 0 0-.98 1.196l1 5a1 1 0 1 0 1.96-.392L4.22 12h15.162l-1.276 2.553a1 1 0 1 0 1.788.894l2-4A1 1 0 0 0 21 10h-3.465l-3.703-5.555A1 1 0 0 0 13 4zm10.132 6-2.667-4H6v4zm-7.157 8a1.4 1.4 0 0 0-1.163.584A3.4 3.4 0 0 1 4 20a3.4 3.4 0 0 1-2.812-1.416 1 1 0 1 1 1.624-1.168A1.4 1.4 0 0 0 4.025 18c.454.012.893-.207 1.163-.584A3.4 3.4 0 0 1 8 16a3.4 3.4 0 0 1 2.812 1.416 1.4 1.4 0 0 0 1.213.584c.454.012.893-.207 1.163-.584A3.4 3.4 0 0 1 16 16a3.4 3.4 0 0 1 2.812 1.416 1.4 1.4 0 0 0 1.213.584c.454.012.893-.207 1.163-.584a1 1 0 1 1 1.624 1.168A3.4 3.4 0 0 1 20 20a3.4 3.4 0 0 1-2.812-1.416A1.4 1.4 0 0 0 15.975 18a1.4 1.4 0 0 0-1.163.584A3.4 3.4 0 0 1 12 20a3.4 3.4 0 0 1-2.812-1.416A1.4 1.4 0 0 0 7.975 18"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgShip;
